import type { FaireProductEntity } from "../../entity_types/product";

export const p_u47pbbc6v7: FaireProductEntity = {
  token: "p_u47pbbc6v7",
  type: "product",
  name: "Garden Sign | Rustic Outdoor Wall Decor | Farmhouse",
  brandName: "North Star Rustics Signs",
  imageUrl:
    "https://cdn.faire.com/fastly/12849bc516f05686f9770df84f96027e66be66fce588f25f57f602c6e65153eb.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/55d167f4548332b40b4c8e6944ee15a901ac4d92e23cc952d83de41910532740.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
